import Box from "@mui/material/Box";
import {FilmIcon} from "../LibrettoEditor/FilmIcon";
import AutoFixHighOutlinedIcon from "@mui/icons-material/AutoFixHighOutlined";
import ClosedCaptionOffOutlinedIcon from "@mui/icons-material/ClosedCaptionOffOutlined";
import AssistantIcon from '@mui/icons-material/Assistant';
import React from "react";
import {CategoryOutlined, TuneOutlined} from "@mui/icons-material";
import Tooltip from "@mui/material/Tooltip";

export const SidebarItems = {
    ASSISTANT: 'assistant',
    PROJECT: 'project',
    AI_TOOLS: 'ai_tools',
    PROPERTIES: 'properties',
    ELEMENTS: 'elements',
    CAPTIONS: 'captions',
    STOCK: 'stock',
}

const V2EditorSidebar = ({
    setSidebarItemSelected,
    sidebarItemSelected,
    showAssistantCallout = false,
    onAssistantOpen,
}) => {

    const mediaBarItemStyle = (isItemSelected) => {

        return {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            padding: "12px",
            paddingX: '8px',
            alignItems: 'center',
            gap: '2px',
            alignSelf: 'stretch',
            background: isItemSelected ? "var(--app-bg-subtle)" : "transparent",
            borderRadius: '8px',
            border: isItemSelected ? '1px solid var(--app-border-muted)' : '1px solid transparent',
            transition: 'background-color 0.12s ease, border-color 0.12s ease',
            "&:hover": {
                background: "var(--app-bg-subtle)",
                borderColor: 'var(--app-border-subtle)',
                cursor: 'pointer',
            }
        }

    }

    const mediaBarItemTextStyle = (isItemSelected) => ({
        color: isItemSelected ? "var(--app-text-primary)" : "var(--app-text-muted)",
        textAlign: 'center',
        fontFamily: 'Inter',
        fontSize: '11px',
        fontStyle: 'normal',
        fontWeight: 400,
        lineHeight: '16px',
        letterSpacing: '0.32px',
        userSelect: 'none',
    })

    const handleClick = (item) => {
        if (sidebarItemSelected === item) {
            setSidebarItemSelected(null);
            return;
        }
        setSidebarItemSelected(item);
    }

    return <>
        <Tooltip
            open={showAssistantCallout}
            arrow
            placement="left"
            disableInteractive
            disableFocusListener
            disableHoverListener
            disableTouchListener
            title={
                <Box sx={{p: 0.25}}>
                    <Box sx={{
                        display: "inline-flex",
                        mb: 0.75,
                        px: 0.75,
                        py: 0.125,
                        borderRadius: "999px",
                        backgroundColor: "rgba(96, 165, 250, 0.18)",
                        color: "#BFDBFE",
                        fontSize: "9px",
                        lineHeight: "14px",
                        fontWeight: 700,
                        letterSpacing: "0.08em",
                    }}>
                        NEW
                    </Box>
                    <Box sx={{fontSize: "13px", lineHeight: "18px", fontWeight: 600, color: "#F8FAFC"}}>
                        Questions while you edit?
                    </Box>
                    <Box sx={{mt: 0.375, fontSize: "12px", lineHeight: "17px", color: "#CBD5E1"}}>
                        Ask how to do something in Libretto.
                    </Box>
                </Box>
            }
            componentsProps={{
                tooltip: {
                    sx: {
                        width: "210px",
                        maxWidth: "210px",
                        p: 1.25,
                        borderRadius: "12px",
                        backgroundColor: "#111827",
                        boxShadow: "0 12px 30px rgba(15, 23, 42, 0.28)",
                    },
                },
                arrow: {sx: {color: "#111827"}},
            }}
        >
            <Box data-tour="sidebar-assistant-button" sx={mediaBarItemStyle(sidebarItemSelected === SidebarItems.ASSISTANT)} onClick={() => {
                if (sidebarItemSelected !== SidebarItems.ASSISTANT) onAssistantOpen?.();
                handleClick(SidebarItems.ASSISTANT)
            }}>
                <Box sx={{position: "relative", width: '24px', height: '24px', color: sidebarItemSelected === SidebarItems.ASSISTANT ? "var(--app-text-primary)" : "var(--app-text-muted)"}}>
                    <AssistantIcon sx={{ fontSize: 21 }}/>
                    {showAssistantCallout && (
                        <Box sx={{
                            position: "absolute",
                            top: -1,
                            right: 0,
                            width: 7,
                            height: 7,
                            borderRadius: "50%",
                            backgroundColor: "#3B82F6",
                            boxShadow: "0 0 0 2px var(--app-bg-surface)",
                        }}/>
                    )}
                </Box>
                <Box sx={mediaBarItemTextStyle(sidebarItemSelected === SidebarItems.ASSISTANT)}>
                    Assistant
                </Box>
            </Box>
        </Tooltip>
        <Box data-tour="sidebar-project-button" sx={mediaBarItemStyle(sidebarItemSelected === SidebarItems.PROJECT)} onClick={() => {
            handleClick(SidebarItems.PROJECT)
        }}>
            <Box sx={{width: '24px', height: '24px', color: sidebarItemSelected === SidebarItems.PROJECT ? "var(--app-text-primary)" : "var(--app-text-muted)"}}>
                <FilmIcon/>
            </Box>
            <Box sx={mediaBarItemTextStyle(sidebarItemSelected === SidebarItems.PROJECT)}>
                Project
            </Box>
        </Box>
        <Box data-tour="sidebar-ai-tools-button" sx={mediaBarItemStyle(sidebarItemSelected === SidebarItems.AI_TOOLS)} onClick={() => {
            handleClick(SidebarItems.AI_TOOLS)
        }}>
            <Box sx={{width: '24px', height: '24px', color: sidebarItemSelected === SidebarItems.AI_TOOLS ? "var(--app-text-primary)" : "var(--app-text-muted)"}}>
                <AutoFixHighOutlinedIcon sx={{ fontSize: 21 }}/>
            </Box>
            <Box sx={mediaBarItemTextStyle(sidebarItemSelected === SidebarItems.AI_TOOLS)}>
                AI Tools
            </Box>
        </Box>
        <Box data-tour="sidebar-properties-button" sx={mediaBarItemStyle(sidebarItemSelected === SidebarItems.PROPERTIES)} onClick={() => {
            handleClick(SidebarItems.PROPERTIES)
        }}>
            <Box sx={{width: '24px', height: '24px', color: sidebarItemSelected === SidebarItems.PROPERTIES ? "var(--app-text-primary)" : "var(--app-text-muted)"}}>
                <TuneOutlined sx={{ fontSize: 21 }}/>
            </Box>
            <Box sx={mediaBarItemTextStyle(sidebarItemSelected === SidebarItems.PROPERTIES)}>
                Properties
            </Box>
        </Box>
        <Box sx={mediaBarItemStyle(sidebarItemSelected === SidebarItems.ELEMENTS)} onClick={() => {
            handleClick(SidebarItems.ELEMENTS)
        }}>
            <Box sx={{width: '24px', height: '24px', color: sidebarItemSelected === SidebarItems.ELEMENTS ? "var(--app-text-primary)" : "var(--app-text-muted)"}}>
                <CategoryOutlined sx={{ fontSize: 21 }}/>
            </Box>
            <Box sx={mediaBarItemTextStyle(sidebarItemSelected === SidebarItems.ELEMENTS)}>
                Elements
            </Box>
        </Box>
        <Box data-tour="sidebar-captions-button" sx={mediaBarItemStyle(sidebarItemSelected === SidebarItems.CAPTIONS)} onClick={() => {
            handleClick(SidebarItems.CAPTIONS)
        }}>
            <Box sx={{width: '24px', height: '24px', color: sidebarItemSelected === SidebarItems.CAPTIONS ? "var(--app-text-primary)" : "var(--app-text-muted)"}}>
                <ClosedCaptionOffOutlinedIcon sx={{ fontSize: 21 }}/>
            </Box>
            <Box sx={mediaBarItemTextStyle(sidebarItemSelected === SidebarItems.CAPTIONS)}>
                Captions
            </Box>
        </Box>
        {/*<Box sx={mediaBarItemStyle(sidebarItemSelected === SidebarItems.STOCK)} onClick={() => {*/}
        {/*    handleClick(SidebarItems.STOCK)*/}
        {/*}}>*/}
        {/*    <Box sx={{width: '24px', height: '24px'}}>*/}
        {/*        <CameraIcon/>*/}
        {/*    </Box>*/}
        {/*    <Box sx={mediaBarItemTextStyle}>*/}
        {/*        Stock*/}
        {/*    </Box>*/}
        {/*</Box>*/}
    </>
}

export default V2EditorSidebar;
